import { AppRoutes } from 'src/routes';
import { returnSearchParam } from 'src/utils';
import { useSearchParam } from './useSearchParam';

export const useReturnSearchParam = (defaultValue: string = AppRoutes.Feed) =>
  useSearchParam(returnSearchParam) ?? defaultValue;
